import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ActivePanelInterface } from '@app/core/interfaces';
import { Dossier } from '@app/core/interfaces/dossier';
import { ScrollService } from '@app/core/scroll/scroll.service';
import { BreadcrumbService } from '@app/core/services/breadcrumb.service';
import * as fromLayout from '@app/store/actions/layout.actions';
import * as fromRoot from '@app/store/app.reducer';
import { select, Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import * as fromMyClaims from './store';
import * as fromClaims from './store/actions/claims.actions';
import * as fromClearActions from './store/actions/clear.actions';

@Component({
    selector: 'ins-claims-overview-container',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: ` <ins-claims-overview
        [activePanel]="activePanel$ | async"
        [loaded]="loaded$ | async"
        [files]="completed$ | async"
        [open]="open$ | async"
        [unfinished]="unfinished$ | async"
        [allClaims]="allClaims$ | async"
    >
    </ins-claims-overview>`,
})
export class ClaimsOverviewContainer implements OnInit, OnDestroy {
    public activePanel$: Observable<ActivePanelInterface> = this.route.queryParams.pipe(
        map((params) => {
            if (!(params.panel && params.scrollTo)) {
                return { panel: '', scrollTo: '' };
            }

            return { panel: params.panel, scrollTo: params.scrollTo };
        })
    );
    public completed$: Observable<Dossier[]> = this.store$.pipe(select(fromMyClaims.getCompletedClaims));
    public open$: Observable<Dossier[]> = this.store$.pipe(select(fromMyClaims.getOpenClaims));
    public unfinished$: Observable<Dossier[]> = this.store$.pipe(select(fromMyClaims.getUnfinishedClaims));
    public allClaims$: Observable<Dossier[]> = this.store$.pipe(select(fromMyClaims.getClaimCollection));
    public loaded$: Observable<boolean> = this.store$.pipe(select(fromMyClaims.isClaimLoaded));

    public baseUrl: string;
    private subscriptions: Subscription = new Subscription();

    constructor(
        private scrollService: ScrollService,
        private store$: Store<fromRoot.State>,
        private route: ActivatedRoute,
        @Inject(DOCUMENT) private document: Document
    ) {
        this.baseUrl = this.document.location.origin;
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
        this.store$.dispatch(new fromClearActions.ClearClaimsStore());
    }

    ngOnInit(): void {
        this.scrollService.scrollToTop(100);

        this.subscriptions.add(
            this.loaded$.subscribe((loaded) => (!loaded ? this.store$.dispatch(new fromClaims.Load()) : false))
        );

        this.store$.dispatch(
            new fromLayout.SetBreadcrumb([
                BreadcrumbService.HOME,
                BreadcrumbService.MYZONE,
                BreadcrumbService.MYZONE_DAMAGES,
            ])
        );
    }
}
